<template>
  <div class="choose-platform-container">
    <h3 class="mb-3">Choose App Platform</h3>
    <div class="platform-row">
      <div
        v-for="card in cards"
        :key="card.key"
        class="platform-card"
        :class="{ selected: selectedPlatform === card.key }"
        @click="selectPlatform(card.key)"
        role="button"
        tabindex="0"
        @keydown.enter.space.prevent="selectPlatform(card.key)"
      >
        <div class="platform-card-content">
          <div class="platform-icon-wrap">
            <img
              :src="getIconUrl(card.icon)"
              class="platform-svg-icon"
              :alt="`${card.label} icon`"
            />
          </div>
          <div class="platform-label">{{ card.label }}</div>
        </div>
        <button
          class="select-btn"
          :class="{ selected: selectedPlatform === card.key }"
          type="button"
          @click.stop="selectPlatform(card.key)"
          aria-pressed="selectedPlatform === card.key"
        >
          {{ selectedPlatform === card.key ? "Selected" : "Select" }}
        </button>
      </div>
    </div>

    <div class="next-btn-wrap" :class="{ selected: selectedPlatform }">
      <slot name="footer-button" :data="selectedPlatform"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChooseAppPlatform",
  props: {
    selectedPlatform: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cards: [
        {
          key: "web",
          label: "Customer Web App",
          icon: "web.svg",
        },
        {
          key: "mobile",
          label: "Customer Mobile App",
          icon: "mobile.svg",
        },
        {
          key: "seller",
          label: "Seller Mobile App",
          icon: "seller.svg",
        },
        {
          key: "agent",
          label: "Agent Mobile App",
          icon: "agent.svg",
        },
      ],
    };
  },
  methods: {
    getIconUrl(filename) {
      try {
        return require(`@/../public/img/svg/${filename}`);
      } catch {
        return "";
      }
    },
    selectPlatform(platform) {
      this.$emit("select-platform", platform);
    },
  },
};
</script>

<style scoped>
.choose-platform-container {
  border: 1px solid #e3eaef;
  border-radius: 8px;
  padding: 24px;
  background: #fff;
  width: 100%;
}

.platform-row {
  display: flex;
  flex-wrap: wrap;
  gap: 36px;
  margin-bottom: 12px;
  justify-content: flex-start;
}

@media (max-width: 1299px) and (min-width: 1199px) {
  .choose-platform-container {
    padding: 10px;
  }
  .platform-row {
    gap: 2px;
  }
}

@media (max-width: 1199px) and (min-width: 769px) {
  .choose-platform-container {
    padding: 16px;
  }
  .platform-row {
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .choose-platform-container {
    padding: 10px;
  }
  .platform-row {
    gap: 12px;
  }
}

@media (max-width: 576px) {
  .choose-platform-container {
    padding: 5px;
  }
  .platform-row {
    gap: 8px;
  }
}

.platform-card {
  background: #fff;
  border: 1.5px solid #e5e5e5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  flex: 1 1 22%;
  min-width: 200px;
  max-width: 25%;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 12px 18px 12px;
  margin-bottom: 0;
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s;
  position: relative;
  box-sizing: border-box;
}
@media (max-width: 1200px) {
  .platform-card {
    min-width: 180px;
    max-width: 48%;
    flex-basis: 48%;
  }
}
@media (max-width: 700px) {
  .platform-card {
    min-width: 160px;
    max-width: 100%;
    flex-basis: 100%;
  }
  .platform-row {
    gap: 12px;
  }
}
.platform-card.selected {
  border-color: #3045be;
  box-shadow: 0 4px 16px rgba(42, 135, 80, 0.12);
  background-color: #eaedfa;
}
.platform-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.platform-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.platform-svg-icon {
  width: 44px;
  height: 44px;
  object-fit: contain;
  margin-bottom: 0;
}
.platform-label {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin-bottom: 0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-btn {
  background-color: #1437c5;
  color: #fff;
  width: 100%;
  font-size: 15px;
  border-radius: 6px;
  padding: 7px 0 6px 0;
  border: none;
  margin-top: 18px;
  font-weight: 600;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(42, 135, 80, 0.1);
}

.select-btn.selected {
  background-color: #3a54bc;
  color: #fff;
}

.select-btn.selected:hover {
  background-color: #3a54bc;
  color: #fff;
}

.select-btn:hover {
  background-color: #3465d6;
}

.next-btn-wrap ::v-deep button {
  background-color: #1437c5;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  padding: 7px 18px;
  border: none;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(42, 135, 80, 0.1);
  cursor: pointer;
}

.next-btn-wrap.selected ::v-deep button {
  background-color: #3a54bc;
  color: #fff;
}

.next-btn-wrap.selected ::v-deep button:hover {
  background-color: #1539c5;
  color: #fff;
}

.next-btn-wrap:not(.selected) ::v-deep button:hover {
  background-color: #555fcc;
  color: #fff;
}
</style>
